(function () {
    const stickyATCFindAncestor = function(el, sel) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
        return el;
    }

    let stickyWidth;
    let stickyAtc;
    let atcInitialized = false;
    let stickyATCTransitioning = false;

    const hypePage = document.querySelectorAll('body.template-page-hype-erg').length > 0;

    const getTextWidth = function(text, font) {
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        return context.measureText(text).width;
      }

    const stickyATCSettings = {
        "classes": {
            openCloseButton: "swatch-dropdown__open-close-button--PLACEHOLDER",
            slidingOptionSelectorOuterContainer: "swatch-dropdown__sliding-option-selector-outer-container--PLACEHOLDER"
        },
        "selectors": {
            atcFormSelector: "#pnt-add-to-cart-form",
            barLabelSpanSelector: ".swatch-dropdown__bar-label span",
            barLabelTextSelector: ".swatch-dropdown__bar-label-text",
            buttonContainerSelector: ".sticky-atc__button-container",
            dropdownOtherSelector: ".swatch-dropdown--other",
            headerMainContentSelector: "#shopify-section-header .header .main-content",
            stickyATCSelector: "#sticky-atc",
            nonHiddenDropdownSelector: ".swatch-dropdown:not(.swatch-dropdown--hide)",
            openCloseButtonSelector: ".swatch-dropdown__open-close-button",
            openCloseButtonContainerSelector: ".swatch-dropdown__open-close-button-container",
            openCloseButtonContainerLabelSelector: ".swatch-dropdown__bar-element-inner-container .swatch-dropdown__open-close-button-container-label",
            optionsContainerSelector: ".sticky-atc__options-container",
            overlaySelector: ".sticky-atc__overlay",
            slidingOptionSelectorOuterContainerSelector: ".swatch-dropdown__sliding-option-selector-outer-container",
            specificOpenCloseButtonNotSelector: `#sticky-atc .swatch-dropdown__open-close-button:not([data-option-index="PLACEHOLDER"])`,
            specificOpenCloseButtonSelector: '#sticky-atc .swatch-dropdown__open-close-button[data-option-index="PLACEHOLDER"]',
            specificOptionNotSelector: '#sticky-atc .swatch-dropdown__sliding-option-selector-outer-container:not([data-option-index="PLACEHOLDER"])',
            swatchDropdownSelector: ".swatch-dropdown" ,
            swatchDropdownSlidingOptionSelectorElementSelector:".swatch-dropdown__sliding-option-selector-element",
            customSwatchOptionListItemLabelSelector: ".swatch-dropdown__sliding-option-custom-swatch-option-list-item-label",
            slidingOptionSelectorInnerContainerSelector: ".swatch-dropdown__sliding-option-selector-inner-container"
        },
        "specs": {
            labelTextDescription: "bold 10px Quicksand",
            desktopSwitchPoint: 1024
        }
    }

    const STICKY_PANEL_CUTOFF_ROW = 8;
    const STICKY_PANEL_BOTTOM_GAP = 12;
    const STICKY_PANEL_TRANSITION_MS = 250;

    let stickyATCResizeRevealTimer;

    const setStickyATCResizing = function(resizing){
        if(!stickyAtc){ return; }

        clearTimeout(stickyATCResizeRevealTimer);

        if(resizing){
            stickyAtc.setAttribute('data-resizing', 'true');
        } else {
            stickyAtc.removeAttribute('data-resizing');
        }
    };

    let stickyATCOverlayHold = false;

    const syncStickyATCOverlay = function(){
        if(stickyATCOverlayHold){ return; }

        const overlay = document.querySelector(`${stickyATCSettings.selectors.overlaySelector}`);
        if(!overlay){ return; }

        const open = !!document.querySelector(`${stickyATCSettings.selectors.stickyATCSelector} ${stickyATCSettings.selectors.swatchDropdownSelector}[aria-expanded="true"]`);

        overlay.setAttribute('data-value', open ? 'open' : 'closed');
    };

    const applyStickyPanelMaxHeight = function(panel){
        if(!panel){ return; }
        const inner = panel.querySelector(`${stickyATCSettings.selectors.slidingOptionSelectorInnerContainerSelector}`);
        const rowEls = panel.querySelectorAll(`${stickyATCSettings.selectors.swatchDropdownSlidingOptionSelectorElementSelector}, ${stickyATCSettings.selectors.customSwatchOptionListItemLabelSelector}`);
        if(!inner || !rowEls.length){
            panel.style.removeProperty('--sticky-atc-panel-max-height');
            panel.style.removeProperty('--sticky-atc-inner-max-height');
            panel.removeAttribute('data-scrollable');
            return;
        }

        const panelTop = panel.getBoundingClientRect().top;
        const innerTop = inner.getBoundingClientRect().top;
        const chrome = innerTop - panelTop;

        const rowMap = new Map();
        rowEls.forEach((el) => {
            const r = el.getBoundingClientRect();
            const key = Math.round(r.top);
            const row = rowMap.get(key) || { top: r.top, height: 0 };
            if(r.height > row.height){ row.height = r.height; }
            rowMap.set(key, row);
        });
        const rows = Array.from(rowMap.values()).sort((a, b) => a.top - b.top);

        if(rows.length >= STICKY_PANEL_CUTOFF_ROW){
            const cutRow = rows[STICKY_PANEL_CUTOFF_ROW - 1];
            const innerHeight = (cutRow.top + (cutRow.height / 2)) - innerTop;
            panel.style.setProperty('--sticky-atc-inner-max-height', `${Math.round(innerHeight)}px`);
            panel.style.setProperty('--sticky-atc-panel-max-height', `${Math.round(chrome + innerHeight + STICKY_PANEL_BOTTOM_GAP)}px`);
            panel.setAttribute('data-scrollable', 'true');
        } else {
            panel.style.removeProperty('--sticky-atc-inner-max-height');
            panel.style.setProperty('--sticky-atc-panel-max-height', `${Math.ceil(chrome + inner.getBoundingClientRect().height) + 1}px`);
            panel.removeAttribute('data-scrollable');
        }
        inner.scrollTop = 0;
    };

    const resetStickyATC = function(){
        const stickyAtc = document.querySelector(`${stickyATCSettings.selectors.stickyATCSelector}`);
        if(!stickyAtc){ return; }

        const openClass = stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace('PLACEHOLDER', 'open');
        const closedClass = stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace('PLACEHOLDER', 'closed');
        const btnOpenClass = stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'open');
        const btnClosedClass = stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'closed');

        stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.slidingOptionSelectorOuterContainerSelector}`).forEach((panel) => {
            panel.classList.remove(openClass);
            panel.classList.add(closedClass);
            panel.setAttribute('data-value', 'closed');
            panel.removeAttribute('data-scrollable');
            panel.style.removeProperty('transform');
            panel.style.removeProperty('--sticky-atc-panel-max-height');
            panel.style.removeProperty('--sticky-atc-inner-max-height');

            if(window.innerWidth >= stickyATCSettings.specs.desktopSwitchPoint){ panel.style.removeProperty('max-height'); }
            const inner = panel.querySelector(`${stickyATCSettings.selectors.slidingOptionSelectorInnerContainerSelector}`);
            if(inner){ inner.scrollTop = 0; }
        });

        stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.swatchDropdownSelector}`).forEach((dropdown) => {
            dropdown.setAttribute('aria-expanded', 'false');
        });

        stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.openCloseButtonSelector}`).forEach((button) => {
            button.classList.remove(btnOpenClass);
            button.classList.add(btnClosedClass);
            button.setAttribute('data-value', 'closed');
            const container = button.closest(`${stickyATCSettings.selectors.openCloseButtonContainerSelector}`);
            if(container){ container.setAttribute('data-value', 'closed'); }
        });

        const html = document.documentElement;
        if(html.getAttribute('data-menu-open') != 'true'){ html.style.removeProperty('overflow'); }
        ['#fc_frame', '#hark-floating-icon-button-hark', '#attentive_creative'].forEach((sel) => {
            const el = document.querySelector(sel);
            if(el){ el.style.removeProperty('display'); }
        });

        stickyATCTransitioning = false;
        stickyATCOverlayHold = false;
        syncStickyATCOverlay();
    };

    const toggleButton = function(e, type, buttonIndex){
        let doNotToggle = false;

        if(e && e.target.closest('.swatch-dropdown__sliding-option-selector-element.option-not-available')){
            doNotToggle = true;
        } else if(e && e.target.closest('.swatch-dropdown__sliding-option-selector-element.soldout')){
            doNotToggle = true;
        }

        if(!doNotToggle) {
                let targetButton = type == 'click_outside' ?  document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonSelector.replace('PLACEHOLDER', '0')}`)[0] : document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonSelector.replace('PLACEHOLDER', `${buttonIndex}`)}`)[0];
                let value = type == 'click_outside' ? 'open' : targetButton.getAttribute('data-value');
                let index = targetButton.getAttribute('data-option-index');
                let buttons = document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonSelector.replace('PLACEHOLDER', `${index}`)}`);
                let allOtherButtons = document.querySelectorAll(`${stickyATCSettings.selectors.specificOpenCloseButtonNotSelector.replace('PLACEHOLDER', `${index}`)}`);
                let allOtherOptionSelectors = document.querySelectorAll(`${stickyATCSettings.selectors.specificOptionNotSelector.replace('PLACEHOLDER', `${index}`)}`);
                let newValue = value == 'closed' ? 'open' : 'closed';

            buttons.forEach((button) => {
                if(allOtherButtons.length > 0) {
                    allOtherButtons.forEach((singleButton) => {
                        singleButton.classList.remove(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'open')}`);
                        singleButton.classList.add(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'closed')}`);
                        singleButton.setAttribute('data-value', 'closed');
                        singleButton.closest(`${stickyATCSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', 'closed');
                    })
                }

                button.classList.remove(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'open')}`);
                button.classList.remove(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', 'closed')}`);
                button.setAttribute('data-value', newValue);
                button.closest(`${stickyATCSettings.selectors.openCloseButtonContainerSelector}`).setAttribute('data-value', newValue);
                button.classList.add(`${stickyATCSettings.classes.openCloseButton.replace('PLACEHOLDER', newValue)}`);

                setTimeout(function () {
                    button.style.pointerEvents = "";
                }, 250);

                const optionSelector = stickyATCFindAncestor(button, `${stickyATCSettings.selectors.swatchDropdownSelector}`).querySelector(`${stickyATCSettings.selectors.slidingOptionSelectorOuterContainerSelector}`);

                if(optionSelector){
                    allOtherOptionSelectors.forEach((singleOptionSelector) => {
                        singleOptionSelector.classList.remove(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "open")}`);
                        singleOptionSelector.classList.add(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "closed")}`);
                        singleOptionSelector.setAttribute('data-value', 'closed');
                        singleOptionSelector.closest(`${stickyATCSettings.selectors.swatchDropdownSelector}`).setAttribute('aria-expanded', false);
                        singleOptionSelector.style.removeProperty(`transform`);
                    })

                    optionSelector.classList.remove(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "open")}`);
                    optionSelector.classList.remove(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", "closed")}`);

                    const freshChat = document.querySelector('#fc_frame');
                    const harkBadge = document.querySelector("#hark-floating-icon-button-hark");
                    const attentiveCreative = document.querySelector("#attentive_creative");


                    if(freshChat){
                        freshChat.style.display = `${newValue == 'open' ? 'none' : 'block'}`
                    }

                    if(harkBadge){
                        harkBadge.style.display = `${newValue == 'open' ? 'none' : 'block'}`
                    }

                    if(attentiveCreative){
                        attentiveCreative.style.display = `${newValue == 'open' ? 'none' : 'block'}`
                    }

                    const html = document.documentElement;

                    if(html.getAttribute('data-menu-open') != "true"){
                        if(newValue == 'open'){
                            html.style.overflow = `hidden`
                        } else {
                            html.style.overflow = ``
                        }
                    }

                    optionSelector.setAttribute('data-value', newValue);
                    optionSelector.classList.add(`${stickyATCSettings.classes.slidingOptionSelectorOuterContainer.replace("PLACEHOLDER", newValue)}`);

                    optionSelector.style.removeProperty(`transform`);
                    if(newValue == 'open' && window.innerWidth >= stickyATCSettings.specs.desktopSwitchPoint){
                        const parentDropdown = optionSelector.closest(`${stickyATCSettings.selectors.swatchDropdownSelector}`);
                        if(parentDropdown){ optionSelector.style.left = `${parentDropdown.offsetLeft - 9}px`; }
                        applyStickyPanelMaxHeight(optionSelector);
                    } else if(newValue == 'open'){
                        const bar = optionSelector.closest('.sticky-atc');
                        if(bar){
                            const barH = bar.offsetHeight;
                            const headerEl = document.querySelector(`${stickyATCSettings.selectors.headerMainContentSelector}`);
                            const headerH = headerEl ? headerEl.offsetHeight : 0;
                            const viewportH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                            bar.style.setProperty('--sticky-atc-bar-height', `${barH}px`);
                            optionSelector.style.maxHeight = `${viewportH - barH - headerH}px`;
                        }
                    }

                    optionSelector.closest(`${stickyATCSettings.selectors.swatchDropdownSelector}`).setAttribute('aria-expanded', `${newValue == 'open' ? true : false }`)

                    syncStickyATCOverlay();
                }
            })
        }
    }

    const widestOpenCloseLabelValue = function(label, values){
        const holder = document.createElement('div');
        holder.style.cssText = 'position:absolute;top:0;left:0;visibility:hidden;pointer-events:none;';

        const clones = values.map((value) => {
            const clone = label.cloneNode(false);
            clone.removeAttribute('id');
            clone.textContent = value;
            clone.style.display = 'inline-block';
            clone.style.width = 'auto';
            clone.style.maxWidth = 'none';
            clone.style.whiteSpace = 'nowrap';
            holder.appendChild(clone);
            return clone;
        });

        label.parentElement.appendChild(holder);

        let widestValue = values[0];
        let widestWidth = -1;
        clones.forEach((clone, index) => {
            const width = clone.getBoundingClientRect().width;
            if(width > widestWidth){
                widestWidth = width;
                widestValue = values[index];
            }
        });

        holder.parentElement.removeChild(holder);

        return widestValue;
    };

    const lockDropdownWidth = function(dropdown){
        const label = dropdown.querySelector(`${stickyATCSettings.selectors.openCloseButtonContainerLabelSelector}`);
        if(!label){
            dropdown.style.removeProperty('width');
            return;
        }

        const optionValues = Array.from(dropdown.querySelectorAll(`${stickyATCSettings.selectors.swatchDropdownSlidingOptionSelectorElementSelector}`))
            .map((option) => option.getAttribute('data-value'))
            .filter((value) => value);

        if(!optionValues.length){
            dropdown.style.removeProperty('width');
            return;
        }

        const widestValue = widestOpenCloseLabelValue(label, optionValues);
        const currentLabel = label.innerHTML;

        dropdown.style.removeProperty('width');
        label.textContent = widestValue;
        const width = dropdown.getBoundingClientRect().width;
        label.innerHTML = currentLabel;

        if(width){ dropdown.style.width = `${Math.ceil(width)}px`; }
    };

    const lockDropdownWidths = function(dropdowns){
        if(stickyWidth >= stickyATCSettings.specs.desktopSwitchPoint){
            dropdowns.forEach((dropdown) => { lockDropdownWidth(dropdown); });
        } else {
            dropdowns.forEach((dropdown) => { dropdown.style.removeProperty('width'); });
        }

        if(stickyAtc){ stickyAtc.setAttribute('data-dropdown-widths-locked', 'true'); }
    };

    const dropdownStyling = function(dropdowns){
        lockDropdownWidths(dropdowns);

        dropdowns.forEach((dropdown) => {

            let amount = dropdowns.length;
            let swatchWidth;
            let dropdownMaxWidth;
            let swatchLabelText = dropdown.querySelector(`${stickyATCSettings.selectors.barLabelTextSelector}`).innerHTML.toUpperCase();
            let labels = dropdown.querySelectorAll(`${stickyATCSettings.selectors.barLabelSpanSelector}`);
            let labelArray = [];
            let maxLabelWidth = 0;

            if(labels.length > 0){
                labels.forEach((label) => {
                    labelArray.push(label.innerHTML);
                });

                labelArray.forEach((labelText) => {
                    let width = Math.ceil(1.02 * Math.ceil(getTextWidth(`${labelText}`, `${stickyATCSettings.specs.labelTextDescription}`))) + 1;
                    if(width > maxLabelWidth){
                        maxLabelWidth = width;
                    }
                })
            }

            swatchWidth = maxLabelWidth + 20 + 22 + 30;

            if(dropdown.classList.contains(`${stickyATCSettings.selectors.dropdownOtherSelector.replace(".", "")}`)){
                dropdownMaxWidth = swatchWidth ;
            } else {
                dropdownMaxWidth = 'auto';
            }

            if(amount < 3 && dropdownMaxWidth !== 'auto'){
                let dropdownLabelwidth = Math.ceil(getTextWidth(`${swatchLabelText}`, `${stickyATCSettings.specs.labelTextDescription}`));

                dropdownMaxWidth = dropdownMaxWidth + dropdownLabelwidth + 14;
            }


            dropdown.style.maxWidth = dropdownMaxWidth !== 'auto' ? `${dropdownMaxWidth}px` : 'auto';

            const panel = dropdown.querySelector('.swatch-dropdown__sliding-option-selector-outer-container');
            if(stickyWidth >= stickyATCSettings.specs.desktopSwitchPoint) {
                panel.style.removeProperty('width');
                panel.style.left = `${dropdown.getBoundingClientRect().left}px`;
            } else {
                panel.style.width = `100%`;
                panel.style.left = ``;
            }
        });
    }


    const initOpenCloseButtons = function(openCloseButtons){
       const TRANSITION_MS = 250;

       const handleClickOnSwatchDropdownButton = function (e) {
        const dropdown = e.currentTarget;
        const btn = dropdown.querySelector('[data-option-index]');
        const index = btn && btn.getAttribute('data-option-index');

        if(stickyATCTransitioning){ return; }

        const clickedOpen = dropdown.getAttribute('aria-expanded') === 'true';
        const otherOpen = Array.from(stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.swatchDropdownSelector}[aria-expanded="true"]`)).find((d) => d !== dropdown);

        stickyATCTransitioning = true;

        if(!clickedOpen && otherOpen){
            const otherBtn = otherOpen.querySelector('[data-option-index]');
            stickyATCOverlayHold = true;
            toggleButton(null, 'click', otherBtn && otherBtn.getAttribute('data-option-index'));
            setTimeout(function(){
                toggleButton(e, 'click', index);
                stickyATCOverlayHold = false;
                syncStickyATCOverlay();
                setTimeout(function(){ stickyATCTransitioning = false; }, TRANSITION_MS + 20);
            }, TRANSITION_MS + 20);
        } else {
            toggleButton(e, 'click', index);
            setTimeout(function(){ stickyATCTransitioning = false; }, TRANSITION_MS + 20);
        }
        };

        openCloseButtons.forEach((button) => {
            button.closest('.swatch-dropdown').addEventListener('click', handleClickOnSwatchDropdownButton);
        });
    }

    const stickyAddToCart = function(event, atcForm){
        event.preventDefault();
        if(validateAddCart(atcForm)) {
            addToCart(atcForm);
        }
        return false;
    }

    const stickyATCThrottle = function(func) {
        let timer;
        return function(event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 500, event);
        };
    };

    const barHeightMobileUpdate = function(contentHeight, element, selectorOuterContainers, height, headerHeight){
        if(contentHeight && contentHeight > 77 && element){
            element.style.height = `${contentHeight}px`;
            if(window.innerWidth >= stickyATCSettings.specs.desktopSwitchPoint){
                element.querySelector('.sticky-atc__options').style.marginBottom = `${(contentHeight - 50) / 2}px`;
            } else {
                element.querySelector('.sticky-atc__options').style.marginBottom = ``;
            }
        } else if(contentHeight && contentHeight <= 77 && element){
            element.style.height = ``;
            element.querySelector('.sticky-atc__options').style.marginBottom = ``;
        }

        const barHeight = element.offsetHeight;
        element.style.setProperty('--sticky-atc-bar-height', `${barHeight}px`);

        if(window.innerWidth < stickyATCSettings.specs.desktopSwitchPoint){
            selectorOuterContainers.forEach((selectorOuterContainer) => {
                selectorOuterContainer.style.maxHeight = `${height - barHeight - headerHeight}px`;
            })
        } else {
            selectorOuterContainers.forEach((selectorOuterContainer) => {
                selectorOuterContainer.style.removeProperty('max-height');
            })
        }

        element.style.removeProperty('transform');
    }

    const updateBarHeight = function(){
        let contentHeight = [document.querySelector(`${stickyATCSettings.selectors.optionsContainerSelector}`).offsetHeight, document.querySelector(`${stickyATCSettings.selectors.buttonContainerSelector}:not(.hide)`).offsetHeight].sort((a, b) => (a > b ? -1 : 1))[0]
        let element = document.querySelector(`${stickyATCSettings.selectors.stickyATCSelector}`);
        let selectorOuterContainers = document.querySelectorAll(`${stickyATCSettings.selectors.slidingOptionSelectorOuterContainerSelector}`)
        let height = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
        let headerEl = document.querySelector(`${stickyATCSettings.selectors.headerMainContentSelector}`);
        let headerHeight = headerEl ? headerEl.offsetHeight : 0;

        element.style.transform = `translateY(0px)`;
        barHeightMobileUpdate(contentHeight, element, selectorOuterContainers, height, headerHeight);
        element.setAttribute('data-verified-mobile', true);
    }

    const updateBarStyling = function(init){
        if (window.innerWidth != stickyWidth || init == true) {
            stickyWidth = window.innerWidth;

            updateBarHeight();

            let dropdowns = stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.nonHiddenDropdownSelector}`);

            if(dropdowns) {
                dropdownStyling(dropdowns);
            }
            initATCButton();
        }
    }

    const initATCButton = function(){
        let atcForm = $(`${stickyATCSettings.selectors.atcFormSelector}`);
        let atcButton = document.querySelector(`${stickyATCSettings.selectors.buttonContainerSelector} button`);

        if(atcForm && atcForm.length && atcButton && !atcInitialized){
            atcButton.onclick = function(e){
                stickyAddToCart(e, atcForm);
                toggleButton(e, 'click_outside')
            }
            atcInitialized = true;
        }
    }

    const initVariantSelectors = function(stickyAtc){

        let variantSelectors = stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.swatchDropdownSlidingOptionSelectorElementSelector}`);
        if(variantSelectors.length > 0){
            variantSelectors.forEach((variantSelector) => {
                variantSelector.onclick = function(e){
                    if(!variantSelector.classList.contains('option-not-available') && !variantSelector.classList.contains('soldout')){
                        let input = variantSelector.querySelector('input[type="radio"]');
                        input.dispatchEvent(new Event('change'));
                        let mainProductInput = document.querySelector(`.options .swatch[data-option-name="${variantSelector.getAttribute('data-key')}"] .variants-wrap input[type="radio"][value="${variantSelector.getAttribute('data-value')}"]`);
                        if(mainProductInput){
                            mainProductInput.dispatchEvent(new Event('change'));
                        }
                    }
                }
            })
        }
    }

    const initStickyATCAccessibility = function(stickyAtc){
        if(!stickyAtc){ return; }

        const dropdowns = stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.nonHiddenDropdownSelector}`);

        const visibleToggle = (dropdown) => {
            const toggles = dropdown.querySelectorAll(`${stickyATCSettings.selectors.openCloseButtonSelector}`);
            return Array.from(toggles).find((t) => t.getBoundingClientRect().width > 0) || toggles[0];
        };

        dropdowns.forEach((dropdown) => {
            const panel = dropdown.querySelector(`${stickyATCSettings.selectors.slidingOptionSelectorOuterContainerSelector}`);
            if(!panel){ return; }
            const toggle = visibleToggle(dropdown);
            const getOptions = () => panel.querySelectorAll(`${stickyATCSettings.selectors.swatchDropdownSlidingOptionSelectorElementSelector}`);

            if(toggle){ toggle.setAttribute('tabindex', '0'); }

            const sync = () => {
                const expanded = dropdown.getAttribute('aria-expanded') === 'true';
                if(toggle){ toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false'); }

                if(!expanded && toggle && panel.contains(document.activeElement)){
                    toggle.focus({ preventScroll: true });
                }
                panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
                getOptions().forEach((opt) => opt.setAttribute('tabindex', expanded ? '0' : '-1'));
                if(expanded){
                    const target = panel.querySelector('.swatch-dropdown__sliding-option-selector-element--selected') || getOptions()[0];
                    if(target){ requestAnimationFrame(() => target.focus({ preventScroll: true })); }
                }
            };
            new MutationObserver(sync).observe(dropdown, { attributes: true, attributeFilter: ['aria-expanded'] });
            sync();

            if(toggle){
                toggle.addEventListener('keydown', (e) => {
                    if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){
                        e.preventDefault();
                        dropdown.dispatchEvent(new MouseEvent('click', { bubbles: true }));
                    }
                });
            }

            panel.addEventListener('keydown', (e) => {
                const opts = Array.from(getOptions());
                if(!opts.length){ return; }
                const idx = opts.indexOf(document.activeElement);
                if(e.key === 'ArrowDown' || e.key === 'ArrowRight'){
                    e.preventDefault();
                    (opts[idx + 1] || opts[0]).focus();
                } else if(e.key === 'ArrowUp' || e.key === 'ArrowLeft'){
                    e.preventDefault();
                    (opts[idx - 1] || opts[opts.length - 1]).focus();
                } else if((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && idx > -1){
                    e.preventDefault();
                    opts[idx].click();
                }
            });
        });

        stickyAtc.addEventListener('keydown', (e) => {
            if(e.key !== 'Escape'){ return; }
            const openDropdown = stickyAtc.querySelector(`${stickyATCSettings.selectors.swatchDropdownSelector}[aria-expanded="true"]`);
            if(openDropdown){
                e.preventDefault();
                toggleButton(null, 'click_outside');
                const toggle = visibleToggle(openDropdown);
                if(toggle){ toggle.focus(); }
            }
        });
    };

    const revealScrollDebounce = function(method, delay){
        clearTimeout(method._tId);
        method._tId = setTimeout(function(){ method(); }, delay);
    };

    const stickyATCHandleScroll = function(){
        const stickyATC = document.getElementById('sticky-atc');
        const mainProductSection = document.querySelector('section.main-product');
        if(!stickyATC || !mainProductSection){ return; }

        const fcBadge = document.querySelector('#fc_frame');
        const attentiveCreative = document.querySelector('#attentive_creative');
        const shouldShow = mainProductSection.getBoundingClientRect().bottom <= 0;

        if(shouldShow){
            document.body.setAttribute('data-pdp-atc-active', 'true');
            setTimeout(function(){
                stickyATC.classList.add('sticky-atc--show');
                stickyATC.classList.add('sticky-atc--grow');
                stickyATC.style.transform = 'translateY(0)';
            }, 10);
            if(fcBadge){ fcBadge.style.marginBottom = window.innerWidth <= stickyATCSettings.specs.desktopSwitchPoint ? '80px' : '0px'; fcBadge.style.transition = 'all .5s ease-in'; }
            if(attentiveCreative){ attentiveCreative.style.marginBottom = window.innerWidth <= stickyATCSettings.specs.desktopSwitchPoint ? '80px' : '0px'; attentiveCreative.style.transition = 'all .5s ease-in'; }
        } else {
            document.body.removeAttribute('data-pdp-atc-active');
            stickyATC.classList.remove('sticky-atc--show');
            let offset = stickyATC.offsetHeight;
            if(hypePage){ offset = 0 - stickyATC.offsetHeight; }
            stickyATC.style.transform = `translateY(-${offset}px)`;
            setTimeout(function(){ stickyATC.classList.remove('sticky-atc--grow'); }, 250);
            if(fcBadge){ fcBadge.style.marginBottom = 0; }
            if(attentiveCreative){ attentiveCreative.style.marginBottom = 0; }
        }
    };

    const initStickyATC = function(){
        stickyWidth = window.innerWidth

        stickyAtc = document.querySelector(`${stickyATCSettings.selectors.stickyATCSelector}`);
        if(!stickyAtc){ return; }

        if(stickyWidth >= stickyATCSettings.specs.desktopSwitchPoint){
            stickyAtc.setAttribute('data-dropdown-widths-locked', 'false');
        }

        let openCloseButtons = stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.openCloseButtonSelector}`);


        if(openCloseButtons){
            initOpenCloseButtons(openCloseButtons);
        };

        initVariantSelectors(stickyAtc);

        initStickyATCAccessibility(stickyAtc);

        window.addEventListener('click', function(e){
            if (!stickyAtc.contains(e.target)){
                toggleButton(e, 'click_outside');
          }
        });

        window.addEventListener("DOMContentLoaded", (event) => {
            updateBarStyling(true)
        });

        if(document.fonts && document.fonts.ready){
            document.fonts.ready.then(function(){
                lockDropdownWidths(stickyAtc.querySelectorAll(`${stickyATCSettings.selectors.nonHiddenDropdownSelector}`));
            });
        }

        const stickyATCResizeEnd = stickyATCThrottle(() => {
            const openDropdown = stickyAtc.querySelector(`${stickyATCSettings.selectors.swatchDropdownSelector}[aria-expanded="true"]`);

            resetStickyATC();
            updateBarStyling();

            if(openDropdown){
                stickyATCResizeRevealTimer = setTimeout(function(){ setStickyATCResizing(false); }, STICKY_PANEL_TRANSITION_MS + 20);
            } else {
                setStickyATCResizing(false);
            }
        });

        window.addEventListener("resize", function(event){
            if(window.innerWidth !== stickyWidth){ setStickyATCResizing(true); }
            stickyATCResizeEnd(event);
        });

        if(!hypePage){
            document.addEventListener('scroll', function(){ revealScrollDebounce(stickyATCHandleScroll, 200); }, { passive: true });
            requestAnimationFrame(stickyATCHandleScroll);
        }
    }

    initStickyATC();
})();
